export const defaultLocale = 'en-GB';
export const definedLocales = [
  'en-US',
  'pt-PT',
  'de',
  'fr',
  'es',
  'it',
  'nl',
  'pl',
] as const;

export const locales = [defaultLocale, ...definedLocales] as const;

export type Locale = (typeof locales)[number];

export type Messages = Record<Locale, Record<string, string>>;

export const localeDisplayNames: Record<Locale, string> = {
  /* eslint-disable @cspell/spellchecker */
  de: 'Deutsch',
  'en-GB': 'English (UK)',
  'en-US': 'English (US)',
  es: 'Español',
  fr: 'Français',
  it: 'Italiano',
  nl: 'Nederlands',
  pl: 'Polski',
  'pt-PT': 'Português',
};
